import { useCallback, useMemo } from 'react'
import api from '../../lib/commons/api'
import { MilestoneRepository } from '../../applications/ports/milestoneRepository'
import {
  MilestoneDetail,
  MilestoneBatchDeltaInput,
} from '../../domain/entity/MilestoneEntity'

export const useMilestoneRepository = (): MilestoneRepository => {
  const fetchAll = useCallback(async (): Promise<MilestoneDetail[]> => {
    const response = await api.functional.request(
      'GET',
      '/api/v1/projects/milestones',
      {},
      true
    )
    return response.json as MilestoneDetail[]
  }, [])

  const updateBatchDelta = useCallback(
    async (input: MilestoneBatchDeltaInput): Promise<void> => {
      await api.functional.request(
        'POST',
        '/api/v1/projects/milestones/delta/batch',
        input
      )
    },
    []
  )

  return useMemo(
    () => ({ fetchAll, updateBatchDelta }),
    [fetchAll, updateBatchDelta]
  )
}
